import React from "react";
import { useLocation } from "react-router-dom";

// Each navigation owns its own credentials, pending requests and consent, even
// when only a fragment changes. Old requests cannot overwrite the new quote.
export default function PrivateRoute({ Page }) {
  const location = useLocation();
  return <Page key={`${location.key}:${location.pathname}:${location.search}:${location.hash}`} />;
}
